import { render, staticRenderFns } from "./ModalAddDocuments.vue?vue&type=template&id=17da8152"
import script from "./ModalAddDocuments.vue?vue&type=script&lang=js"
export * from "./ModalAddDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17da8152')) {
      api.createRecord('17da8152', component.options)
    } else {
      api.reload('17da8152', component.options)
    }
    module.hot.accept("./ModalAddDocuments.vue?vue&type=template&id=17da8152", function () {
      api.rerender('17da8152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Legajos/LegajoDocuments/ModalAddDocuments.vue"
export default component.exports